import { ScriptLanguage } from "@/script/model"

const patterns = {
  [ScriptLanguage.JavaScript]:
    /function\s*(?:[A-Za-z_$][\w$]*)?\s*\(\s*([^)]*)\)/m,
  [ScriptLanguage.Python]: /def\s+[A-Za-z_]\w*\s*\(\s*([^)]*)\)/m,
  [ScriptLanguage.Php]: /function\s*(?:[A-Za-z_]\w*)?\s*\(\s*([^)]*)\)/m,
}

export const argNames = (lang: ScriptLanguage, code: string | undefined) => {
  if (!code) {
    return []
  }
  const m = code.match(patterns[lang])
  const argsStr = m?.[1]
  if (!argsStr?.trim()) {
    return []
  }

  return argsStr // get inside-the-parens
    .split(",") // split args
    .map((a) => a.trim()) // trim whitespace
    .filter((a) => a) // drop empties
    .map((arg) => {
      const name =
        arg
          // grab name (with optional leading "$"), before ":" or "=" or end
          .match(/(\$?[A-Za-z_]\w*)\b(?=\s*(?:[:=]|$))/)?.[1] ?? ""

      return name.replace(/^\$/, "") // strip PHP’s "$"
    })
    .filter(Boolean)
}

/**
 * Generates a JSON Schema string from function argument names.
 * All parameters are typed as string and required (v1).
 */
export const argsJsonSchema = (
  lang: ScriptLanguage,
  code: string | undefined,
) => {
  const args = argNames(lang, code)

  return JSON.stringify(
    {
      type: "object",
      properties: Object.fromEntries(
        args.map((name) => [name, { type: "string" }]),
      ),
      required: args,
      additionalProperties: false,
    },
    null,
    2,
  )
}
